import { facilitySparten } from '../../../mocks/ueber-uns';

export default function FacilitySparten() {
  return (
    <section className="py-20 sm:py-24 bg-[#f5f1eb]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest text-[#0D2B4E]/75 uppercase mb-3">
            Was wir leisten
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0D2B4E] mb-4">
            Facility Management aus einer Hand
          </h2>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
            Wir sind kein klassischer Handwerksbetrieb — wir sind ein Facility-Unternehmen mit mehreren
            Sparten. Was wir nicht selbst machen, erledigen unsere geprüften Partnerunternehmen.
            So oder so: Sie haben immer nur einen Ansprechpartner.
          </p>
        </div>

        {/* Sparten Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-14">
          {facilitySparten.map((sparte) => (
            <div
              key={sparte.id}
              className={`rounded-xl border border-gray-100 bg-gradient-to-br ${sparte.color} p-7 hover:border-gray-200 transition-colors`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${sparte.accent} mb-5`}>
                <i className={`${sparte.icon} text-white text-xl`} />
              </div>
              <div className="mb-1">
                <span className="text-xs font-semibold tracking-widest text-gray-500 uppercase">{sparte.subtitle}</span>
              </div>
              <h3 className="text-xl font-bold text-[#0D2B4E] mb-3">{sparte.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-5">{sparte.description}</p>
              <div className="flex flex-wrap gap-2">
                {sparte.leistungen.map((l) => (
                  <span
                    key={l}
                    className="text-xs font-medium bg-white/90 text-[#0D2B4E]/80 border border-gray-200 px-3 py-1 rounded-full"
                  >
                    {l}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Partner-Ansatz Banner */}
        <div className="rounded-2xl bg-[#0D2B4E] px-8 sm:px-12 py-8 sm:py-10 flex flex-col lg:flex-row items-center gap-8">
          <div className="w-14 h-14 flex items-center justify-center flex-shrink-0 rounded-xl bg-white/10">
            <i className="ri-links-line text-white text-2xl" />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-xl font-bold text-white mb-2">
              Eigenleistung + starkes Partnernetzwerk
            </h3>
            <p className="text-white/85 text-sm sm:text-base leading-relaxed">
              Vieles machen wir selbst — mit eigenem, geschultem Personal. Für Gewerke, die tiefe
              Spezialisierung erfordern, greifen wir auf ein Netzwerk aus vertrauenswürdigen
              Fachbetrieben zurück. Jeder Partner wird sorgfältig ausgewählt und steht für dieselben
              Qualitätsansprüche wie IGM Facility Service selbst. Das Ergebnis: Sie bekommen immer die beste Lösung —
              ohne den Aufwand, selbst koordinieren zu müssen.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col gap-3 flex-shrink-0">
            <div className="flex items-center gap-3 bg-white/10 rounded-lg px-4 py-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-[#C8860A] text-base" />
              </div>
              <span className="text-white text-sm font-medium whitespace-nowrap">Eigenes Fachpersonal</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 rounded-lg px-4 py-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-[#C8860A] text-base" />
              </div>
              <span className="text-white text-sm font-medium whitespace-nowrap">Geprüfte Partner</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 rounded-lg px-4 py-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-[#C8860A] text-base" />
              </div>
              <span className="text-white text-sm font-medium whitespace-nowrap">Ein Ansprechpartner</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
